import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import useAppName from '../hooks/useAppName';
import {
  HONDA_SITE_NAME,
  ACURA_SITE_NAME,
  MC_SITE_NAME,
  PE_SITE_NAME,
  PSP_SITE_NAME,
  MARINE_SITE_NAME,
} from '../utils/constants';

export const variantsMap = {
  variant1: HONDA_SITE_NAME,
  variant2: ACURA_SITE_NAME,
  variant3: MC_SITE_NAME,
  variant4: PE_SITE_NAME,
  variant5: MARINE_SITE_NAME,
  variant6: PSP_SITE_NAME,
};

export const { variant1, variant2, variant3, variant4, variant5 } = variantsMap;

const VariantContext = createContext('');

const VariantProvider = ({ children }) => {
  const appName = useAppName();

  let variant;

  switch (appName) {
    case HONDA_SITE_NAME:
      variant = variant1;
      break;

    case ACURA_SITE_NAME:
      variant = variant2;
      break;
    case MC_SITE_NAME:
      variant = variant3;
      break;
    case PE_SITE_NAME:
      variant = variant4;
      break;
    case MARINE_SITE_NAME:
    case PSP_SITE_NAME:
    default:
      variant = variant5;
      break;
  }

  return <VariantContext.Provider value={variant}>{children}</VariantContext.Provider>;
};

const useVariant = () => {
  const variant = useContext(VariantContext);
  if (!variant) {
    console.warn('Variant Context missing');
  }
  return variant;
};

VariantProvider.propTypes = {
  children: PropTypes.node,
};

export { VariantContext, VariantProvider, useVariant };
